import React, { useState, useEffect } from "react";
import "./PriceTab.css";
import { useDispatch, useSelector } from "react-redux";
import {
  CancellSubscription,
  getCurrentPlan,
} from "../../../Redux/actions/commonActtion";
import { toast } from "react-toastify";
import CustomToast, {
  customToatStyle,
} from "../../../Components/CustomToast/CustomToast";
import { info } from "../../../assets/icons";
const styles = {
  fontFamily: "Avenir book",
  fontWeight: "500",
  fontStyle: "normal",
  textDecoration: "none",
};
const lableStyles = {
  fontFamily: "Avenir book",
  fontWeight: "600",
  fontStyle: "normal",
  textDecoration: "none",
};
const currentPlanStyles = {
  fontWeight: "600",
  fontStyle: "normal",
  textDecoration: "none",
};
const upgrdBtnStyle = {
  // backgroundImage:'var(--popup-background-image)',
  // backgroundColor: '#9ef0f0',
  color: "white",
  borderRadius: "1rem",
  padding: "4px 22px",
  border: "1px solid #54606c",
};

const PlanCubeCard = ({
  lable,
  planPurchaseDate,
  currentPlan,
  support,
  rendersLimit,
  projectLimits,
  validity,
  planRenueDate,
  buttonLable,
  onClick,
  paymentType,
  order_id,
  subscription_status,
  expiryString,
  renewalString,
}) => {
  const dispatch = useDispatch();
  // const [isAllowUser, setIsAllowUser] = useState(false)
  // const allowUserList = process.env.REACT_APP_ALLOW_USERS.split(',');
  // const logedInUser = JSON.parse(localStorage.getItem('user'))
  const handleCancell = async (val) => {
    const res = await dispatch(CancellSubscription(order_id));
    if (res.data?.success) {
      toast.success(res.data.message);
      await dispatch(getCurrentPlan());
    }
  };
  // const handleAlert = () => {
  //     toast(
  //         <CustomToast
  //             title=""
  //             content={' This upgrade option is in testing mode and will be enabled in a few days'} />,
  //         customToatStyle);
  // }
  // useEffect(() => {
  //     allowUserList?.forEach(user => {
  //         if (logedInUser?.email === user) {
  //             setIsAllowUser(true)
  //             return;
  //         }
  //     });
  // }, [])
  return (
    <>
      <div
        className="renderUPgrade w-[45%] flex jus py-[3%] px-[5%] flex-col "
        style={{
          border: "0px solid #d1d1d1",
          borderRadius: "16px",
          backgroundColor: "var(--shadeBlack)",
          color: "#f8f8f6",
        }}
      >
        <div className="w-full px-1 py-1">
          <div className="flex justify-between">
            <div>
              <p className="lg:text-[1.3rem] text-[0.9rem]" style={lableStyles}>
                {lable}
              </p>
            </div>
            <div className="">
              <img
                // className="w-5"
                src={info}
                alt=""
                style={{ cursor: "pointer" }}
                onClick={() => window.open(`/help/670e655049a4f8d9d08f37f5`)}
              />
            </div>
          </div>

          <p
            className="Syne700 lg:text-[2rem] md:text-[1.3rem] sm:text-[1rem]"
            style={currentPlanStyles}
          >
            {currentPlan}
          </p>

          <p
            className="sm:leading-[1.125rem] priceCubetext tracking-wide text-[14px]"
            style={styles}
          >
            {rendersLimit}
          </p>

          <p
            className="sm:leading-[1.125rem] priceCubetext tracking-wide text-[14px]"
            style={styles}
          >
            {projectLimits}
          </p>

          {/* <p className="sm:leading-[1.125rem] priceCubetext  tracking-wide text-sm" style={styles}>{support}</p> */}

          <p
            className="sm:leading-[1.125rem] priceCubetext capitalize tracking-wide text-[14px]"
            style={styles}
          >
            {validity}
          </p>

          {/* <p className="sm:leading-[1.125rem] priceCubetext  tracking-wide text-[14px]" style={styles}>{planRenueDate}</p> */}

          <p
            className="sm:leading-[1.125rem] priceCubetext  tracking-wide text-[14px]"
            style={styles}
          >
            {planPurchaseDate ? `Purchase Date ${planPurchaseDate}` : null}
          </p>

          {subscription_status === 2 ? (
            <p
              className="sm:leading-[1.125rem] priceCubetext  tracking-wide text-[14px]"
              style={styles}
            >
              {expiryString}
            </p>
          ) : (
            <p
              className="sm:leading-[1.125rem] priceCubetext  tracking-wide text-[14px]"
              style={styles}
            >
              {renewalString}
            </p>
          )}
        </div>

        <div className=" mt-3">
          {buttonLable && (
            <div className="flex items-start p-1 ">
              <button
                className="unSunbscribeBtn Syne700 upgrad_btn uppercase sm:text-base w-[180px] "
                type="submit"
                onClick={onClick}
                style={upgrdBtnStyle}
              >
                {buttonLable}
              </button>
            </div>
          )}

          {paymentType === 2 && subscription_status === 1 && (
            <div className="flex items-start p-1 mt-[1rem]">
              <button
                className="unSunbscribeBtn Syne700 sm:text-base  uppercase w-[180px]"
                style={upgrdBtnStyle}
                onClick={handleCancell}
              >
                Unsubscribe
              </button>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default PlanCubeCard;
